import { SceneManager } from './core/managers/SceneManager';
import { FacebookManager } from './core/managers/facebook/FacebookManager';

export class Loader {
    private static _instance: Loader;
    private app: PIXI.Application;

    constructor() {
        this.app = SceneManager.getInstance()._app;
    }

    public loadInitialAssets(onLoaded: () => {}, managerClass: any): void {
        this.addSpritesheets();
        this.addJSON();
        // this.addSounds();

        this.app.loader.onProgress.add((eventData: any): void => {
            managerClass.getInstance().setLoadingProgress(eventData.progress);
        });
        this.app.loader.load(onLoaded);
    }

    private addSpritesheets(): void {
        const spritesheets: string[] = [
            'ui-0.json',
            'ui-1.json',
        ];

        spritesheets.forEach((spritesheetName: string) => {
            this.app.loader
                .add(spritesheetName, 'assets/spritesheet/' + spritesheetName);
        });
    }

    private addJSON(): void {
        this.app.loader
            .add('assets/json/levels.json')
            .add('assets/json/offers.json')
            .add('assets/json/translation.json');
    }

    private addSounds(): void {
        this.app.loader
            .add('assets/sounds/menu-track.mp3')
            .add('assets/sounds/movement.mp3');
    }

    public static getInstance(): Loader {
        return this._instance || (this._instance = new this());
    }

    public loadShareAsset(name: string, onSuccess: (resourceName: string) => void): void {
        // TODO: SUPPORT JPG
        let resourceName: string = 'assets/share/' + name + '.png';
        if (this.app.loader.loading) {
            resourceName = 'mod_share_invite';
            onSuccess(resourceName);
        } else if (this.app.loader.resources['assets/share/' + name + '.png']) {
            onSuccess(resourceName);
        } else {
            this.app.loader
                .add('assets/share/' + name + '.png');
            this.app.loader.load((): void => {
                onSuccess(resourceName);
            });
        }
    }

    public loadSounds(soundNames: string[], musicNames: string[], callback: (loader: PIXI.Loader) => void): void {
        soundNames.forEach((soundName: string): void => {
            this.app.loader
                .add('assets/sounds/' + soundName + '.mp3');
        });
        musicNames.forEach((musicName: string): void => {
            this.app.loader
                .add('assets/sounds/' + musicName + '.mp3');
        });
        this.app.loader.load((): void => {
            callback(this.app.loader);
        });
    }

    public getJson(name: string): any {
        return this.app.loader.resources['assets/json/' + name + '.json'].data;
    }
}